import { Dispatch, SetStateAction, useEffect } from 'react';
import { useGainsightService } from '@mews/framework';
import { KeyValue } from '@mews/enums';
import { SearchStateProps } from '../Assistant';

export const useHandleSearchShortcuts = (
    setSearchState: Dispatch<SetStateAction<SearchStateProps>>,
    handleUnFocused: () => void
) => {
    const gainsightService = useGainsightService();

    return useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.altKey && event.code === 'KeyF') {
                const { activeElement } = document;
                if (activeElement?.tagName === 'INPUT' || activeElement?.tagName === 'TEXTAREA') {
                    return;
                }
                event.stopPropagation();
                event.preventDefault();
                setSearchState((prev) => ({
                    ...prev,
                    focused: true,
                }));
                gainsightService?.trackEvent('AssistantShortcutSearchOpened');
            } else if (event.code === KeyValue.Escape) {
                event.stopPropagation();
                event.preventDefault();
                handleUnFocused();
                gainsightService?.trackEvent('AssistantShortcutSearchClosed');
            }
        };

        window.addEventListener('keydown', handleKeydown);

        return () => window.removeEventListener('keydown', handleKeydown);
    }, [gainsightService, setSearchState, handleUnFocused]);
};
